import React from 'react';
import autoBind from 'react-autobind';

import moment from 'moment';

import { Row, Col } from 'react-bootstrap';

import { MaskedTextBox } from '@progress/kendo-react-inputs';

import GridFilterBase from './grid.filter.base';

import _ from 'lodash';

const I = {
  SINCE: 0,
  UNTIL: 1,
};

class GridFilter extends GridFilterBase {
  constructor(props) {
    super(props, {
      sinceDate: {
        title: 'Data/Hora inicial:',
        type: 'date',
        operation: 'sinceDate',
      },
      untilDate: {
        title: 'Data/Hora final:',
        type: 'date',
        operation: 'untilDate',
      },
    });
    autoBind(this);
  }

  getDefaultInputValues(column) {
    return {
      isNullable: !!column.isNullable,
      value: null,
      valueTime: null,
      SomenteNull: column.checkSomenteNull,
    };
  }

  updateIcon(column) {
    let filterColumns = column.inputs.filter(
      (x) => x.value || x.value === 0 || (x.advancedSearchValues && x.advancedSearchValues.length != 0) || x.SomenteNull
    );
    column.isFiltered = filterColumns && filterColumns.length != 0;
  }

  handleJustNull(e) {
    let { column } = this.props;
    this.somenteNull = e.target.checked;

    column.inputs.forEach(
      (x) => (
        (x.SomenteNull = this.somenteNull),
        (x.value = this.somenteNull ? ' ' : ''),
        (x.valueTime = this.somenteNull ? ' ' : '')
      )
    );
    this.updateContextColumn(column);
  }

  async isValid() {
    const { column } = this.props;
    const { inputs } = column;
    var initialDate = this.strToDate(inputs[I.SINCE]);
    var finalDate = this.strToDate(inputs[I.UNTIL]);

    if (inputs[I.SINCE].SomenteNull || inputs[I.UNTIL].SomenteNull) return true;

    if (!inputs[I.SINCE].value && !inputs[I.UNTIL].value) return true;

    if (inputs[I.SINCE].value) {
      if (inputs[I.SINCE].value.indexOf('_') > -1) {
        this.clearInputs();
        return true;
      }

      if (inputs[I.SINCE].value.substr(-4) == '0000' || !initialDate.isValid()) {
        _alert.warning("Não será aplicado o filtro por data pois a 'Data Inicial' informada é inválida.");
        this.clearInputs();
        return false;
      }

      if(!inputs[I.UNTIL].value)
        return true;
    }

    if (inputs[I.UNTIL].value) {
      if (inputs[I.UNTIL].value.indexOf('_') > -1) {
        this.clearInputs();
        return true;
      }

      if (inputs[I.UNTIL].value.substr(-4) == '0000' || !finalDate.isValid()) {
        _alert.warning("Não será aplicado o filtro por data pois a 'Data Final' informada é inválida.");
        this.clearInputs();
        return false;
      }

      if(!inputs[I.SINCE].value)
        return true;
    }

    if (initialDate <= finalDate) {
      return true;
    } else
      _alert.warning(
        "Não será aplicado o filtro por data pois a 'Data inicial' deve ser menor ou igual a 'Data Final'."
      );
    
    this.clearInputs();
    return false;
  }

  clearInputs() {
    const { column } = this.props;
    const { inputs } = column;
    inputs.forEach((x) => {
      x.value = null;
      x.valueTime = null;
    });
    this.updateContextColumn(column);
  }

  strToDate(input) {
    return moment(`${input.value}T${input.valueTime}`, 'D/M/YYYYTHH:mm:ss');
  }

  isValidField(target, field) {
    let { value } = target;
    if (value.indexOf('_') > -1) return false;
    if (field == 'value') {
      return moment(value, 'D/M/YYYY').isValid();
    } else if (field == 'valueTime') {
      return moment(value, 'hh:mm:ss').isValid();
    }
  }

  handleChangeValue(index, field, prop) {
    let { column } = this.props;
    return (e) => {
      let { value } = e.target;

      column.inputs[index][field] = _.trim(e.target.rawValue) ? value : null;

      if (this.isValidField(e.target, field)) {
        if (column.inputs[I.SINCE].value && !column.inputs[I.SINCE].valueTime)
          column.inputs[I.SINCE].valueTime = '00:00:00';
          
        if (column.inputs[I.UNTIL].value && !column.inputs[I.UNTIL].valueTime) 
          column.inputs[I.UNTIL].valueTime = '23:59:59';
      }

      column.isFiltered =
        column.inputs
          .map(function (input) {
            return input.value != null && input.valueTime != null;
          })
          .indexOf(false) !== -1;

      this.updateContextColumn(column, false);
    };
  }

  handleBlur(index, field) {
    let { column } = this.props;

    let value = column.inputs[index][field];
    if (value && !this.isValidField({ value }, field)) {
      column.inputs[index][field] = null;
      column.inputs[index].valueTime = null;
      this.updateContextColumn(column);
    }

    if (!value && field == 'value') {
      column.inputs[index].valueTime = null;
      this.updateContextColumn(column);
    }
  }

  render() {
    const { column } = this.props;
    const { inputs } = column;
    if (!inputs) return null;

    let checked = inputs.length > 0 ? inputs[0].SomenteNull : column.checkSomenteNull

    return (
      <ul>
        {inputs.map(this.renderInput)}
        {column.isNullable && (
          <li>
            <div className="filterColunm mt-2">
              <label className="checkbox">
                <input
                  className="handleJustNull"
                  type="checkbox"
                  onChange={this.handleJustNull}
                  checked={checked}
                />
                Somente Vazio
              </label>
            </div>
          </li>
        )}
      </ul>
    );
  }

  renderInput(input, index) {
    const { hash } = this.props;

    return (
      <li className="filterLine" key={index}>
        <div className="filterColunm">
          <label htmlFor="input">{input.title}</label>
          <Row>
            <Col lg={12}>
              <MaskedTextBox
                name={hash}
                mask="99/99/9999"
                placeholder="__/__/____"
                maskValidation={false}
                className="form-control"
                value={input.value || ''}
                onChange={this.handleChangeValue(index, 'value')}
                onBlur={() => this.handleBlur(index, 'value')}
                disabled={input.SomenteNull}
              />
              <MaskedTextBox
                name={hash}
                mask="99:99:99"
                placeholder="__:__:__"
                maskValidation={false}
                className="form-control"
                value={input.valueTime || ''}
                onChange={this.handleChangeValue(index, 'valueTime')}
                onBlur={() => this.handleBlur(index, 'valueTime')}
                disabled={input.SomenteNull}
              />
            </Col>
          </Row>
        </div>
      </li>
    );
  }
}

export default GridFilter;
